var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcnBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474847",
    fillRule: "evenodd",
    d: "M8 3H6.077C5.461 3 5 3.252 5 3.889V5h3l-.239 3H5v8H2V8H0V5h2V3.077C2 1.055 3.064 0 5.461 0H8v3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcnBlack);
export default __webpack_public_path__ + "static/media/fb-icn-black.b659a6035fb0bf26a15110a7ed9bce08.svg";
export { ForwardRef as ReactComponent };